/** Stored API values for publish venue platform (must match flock-be NormalizePlatform). */
export const PUBLISH_VENUE_PLATFORM_OPTIONS = [
  { value: 'arc_xp', label: 'Arc XP' },
  { value: 'wordpress', label: 'Wordpress' },
  { value: 'black_sheep_portal', label: 'Black Sheep Portal' },
] as const;

export type PublishVenuePlatformValue = (typeof PUBLISH_VENUE_PLATFORM_OPTIONS)[number]['value'];

export function platformLabelForValue(value: string): string {
  const o = PUBLISH_VENUE_PLATFORM_OPTIONS.find((x) => x.value === value);
  return o?.label ?? value;
}

/** Accepts host or full URL; returns true if URL parses with http(s) and hostname. */
export function isValidPublishVenueDomainUrl(raw: string): boolean {
  const s = raw.trim();
  if (!s) return false;
  let candidate = s;
  if (!/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(s)) {
    candidate = `https://${s}`;
  }
  try {
    const u = new URL(candidate);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return false;
    return Boolean(u.hostname);
  } catch {
    return false;
  }
}
